(function (angular) {

  angular.module("alk.companyAdmin", ["alk.email"]);

})(window.angular);

require("./companyAdmin.controller.js");
require("./commonAccountUsers.directive.js");
require("./addGroups.controller");



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-company-admin/module.js